import { DateTime } from "luxon";
import { SweepingCapacityByPeriod } from "./SweepingCapacityByPeriod";

export const findSweepingCapacityByPeriod =
  (timeUnit: "year" | "quarter" | "month" | "week", time: DateTime<true>) =>
  (it: SweepingCapacityByPeriod) => {
    if (timeUnit === "month" && it.timeUnit === timeUnit) {
      return it.time === time.month;
    } else if (timeUnit === "year" && it.timeUnit === timeUnit) {
      return it.time === time.year;
    } else if (timeUnit === "quarter" && it.timeUnit === timeUnit) {
      return it.time === time.quarter;
    } else if (timeUnit === "week" && it.timeUnit === timeUnit) {
      return it.time === time.weekNumber;
    } else {
      return false;
    }
  };
